import autoBind from "auto-bind";
import Page from "../../common/models/page";
import * as OrdersApi from "../../api/orders";
import DataSource from "src/core/data-sources/dataSource";
import EventBus from "src/core/common/eventBus";
import SimpleOrder from "../../common/models/simpleOrder";

class OrdersListDataSource extends DataSource {
  cache = {};

  constructor() {
    super();
    autoBind(this);
  }

  doGet(keyValueMap) {
    const params = this.getParams(keyValueMap);

    return OrdersApi.list(params).then((response) => {
      const key = this.getCacheKey(params);
      this.cache = {};
      this.cache[key] = new Page({
        meta: response.meta,
        objects: response.data.map(
          (element) => new SimpleOrder(element, response.included)
        ),
      });
      return this.cache[key];
    });
  }

  getCached(keyValueMap) {
    const params = this.getParams(keyValueMap);
    return this.cache[this.getCacheKey(params)];
  }

  getCacheKey = (params) => {
    return JSON.stringify(params);
  };

  getParams = ({limit, offset, order, filters}) => {
    const parsedFilters = this.parseFilters(filters);
    return {limit, offset, order, ...parsedFilters};
  };

  getEventBus() {
    return eventBus;
  }
}

const eventBus = new EventBus();

export default OrdersListDataSource;
